export default __webpack_public_path__ + "static/media/blue_back.efc58620.svg";